module.exports = __webpack_public_path__ + "static/media/raisin.816e6744.svg";